import { useEffect, useRef, useState } from "react";
import { useConfigurationNavigationItems, useConfigurationResetKey, } from "@plansoft-configuration-renderer/framework";
import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
const logger = new ConsoleLogger("SubconfigurationNavigation", LogLevels.warn);
/**
 * Hook for handling subconfiguration navigation
 * @param items
 * @returns
 */
export function useSubconfigurationNavigation(items) {
    const expandedItems = useConfigurationNavigationItems();
    const resetKey = useConfigurationResetKey();
    const resetKeyRef = useRef(resetKey);
    const [activePath, setActivePath] = useState(() => { var _a; return (_a = items[0]) === null || _a === void 0 ? void 0 : _a.path; });
    // update tab if there is a selection in configuration tree
    useEffect(() => {
        // find the expanded item in the items
        const expandedItem = expandedItems.find((item) => items.find((item2) => item2.path === item.path));
        // after the last expandedItem is found expandedItems will be reset to [] by useConfigurationScrolling
        // this effect will then run again and end upo in this condition
        if (expandedItem == null) {
            return;
        }
        // if found, navigate to the item
        logger.info("useSubconfigurationNavigation: update from expandedItems", expandedItem);
        setActivePath(expandedItem.path);
    }, [items, expandedItems, setActivePath]);
    // set the path to the first item if the current path is not found
    // this prevents spontaneous jumping of navigation when the configuration is changed or reset
    useEffect(() => {
        var _a;
        const currentIndex = items.findIndex((item) => item.path === activePath);
        const pathNotFound = currentIndex === -1;
        const resetKeyChanged = resetKeyRef.current !== resetKey;
        resetKeyRef.current = resetKey;
        if (pathNotFound || resetKeyChanged) {
            // fallback can still be undefined if items is empty
            setActivePath((_a = items[0]) === null || _a === void 0 ? void 0 : _a.path);
            logger.info("useSubconfigurationNavigation: fallback to first item", {
                pathNotFound,
                resetKeyChanged,
            });
        }
    }, [items, activePath, resetKey]);
    const currentIndex = items.findIndex((item) => item.path === activePath);
    const nextDisabled = currentIndex === items.length - 1;
    const previousDisabled = currentIndex <= 0;
    const activeItem = items.find((item) => item.path === activePath);
    function next() {
        const nextIndex = currentIndex + 1;
        if (nextIndex < items.length) {
            setActivePath(items[nextIndex].path);
        }
    }
    function previous() {
        {
            const previousIndex = currentIndex - 1;
            if (previousIndex >= 0) {
                setActivePath(items[previousIndex].path);
            }
        }
    }
    function resetActivePath() {
        if (activeItem != null) {
            activeItem.reset();
        }
    }
    return {
        activePath,
        activeItem,
        setActivePath,
        resetActivePath,
        next,
        previous,
        nextDisabled,
        previousDisabled,
    };
}
//# sourceMappingURL=useSubconfigurationNavigation.js.map